/* eslint-disable no-console */

import axios from 'axios';
import config from './config/config';

const HTTP = axios.create();
// Add a request interceptor
HTTP.interceptors.request.use((request) => {
  request.headers = {
    'Content-Type': 'application/json',
  };
  if (request.url.indexOf('http') === -1) {
    // Do something before request is sent
    request.url = config.BASE_URL + request.url;
  }
  return request;
}, (error) => {
  // Do something with request error
  return Promise.reject(error);
});

export default HTTP;
